export default __webpack_public_path__ + "static/media/icon_phone_green.5ba5577d.svg";